import React from 'react';
import PropTypes from 'prop-types';
import './Steps.scss';

/**
 * @group Components
 * Displays article steps
 */

const Steps = (props) => {
  const { opts, children } = props;
  const { Content } = opts;
  return (
    <div className="step">
      {Content.map((step, index) => {
        return (
          <div key={step.name}>
            <div className="step-header">
              <span id={step.name} className="stepnum">{step.stepCount}</span>
              <div className="step-title">
                {step.text}
              </div>
            </div>
            <div>
              {children}
            </div>
          </div>
        );
      })}
    </div>
  );
};

Steps.propTypes = {
  opts: PropTypes.shape({
    stepCount: PropTypes.string,
    text: PropTypes.string,
    name: PropTypes.string,
    Content: PropTypes.array,
  }).isRequired,
  children: PropTypes.instanceOf(Array)
};

Steps.defaultProps = {
  children: []
};

export default Steps;
